import baseApi from 'shared/api/baseApi';

import type {
  AgentTestRun,
  AgentTestRunDetail,
  CreateRunBody,
  PreviewRunBody,
  PreviewRunResult,
  RunsListParams,
  RunsListResponse,
} from '../model/run';

const runsApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    getRuns: build.query<RunsListResponse, RunsListParams>({
      query: ({ projectId, status, page, limit }) => ({
        url: '/admin/agentEvals/runs',
        method: 'GET',
        params: {
          projectId,
          page,
          limit,
          ...(status ? { status } : {}),
        },
      }),
      providesTags: [{ type: 'AgentTestRuns', id: 'LIST' }],
    }),
    getRun: build.query<AgentTestRunDetail, number>({
      query: (runId) => ({
        url: `/admin/agentEvals/runs/${runId}`,
        method: 'GET',
      }),
      providesTags: (_result, _error, runId) => [{ type: 'AgentTestRuns', id: runId }],
    }),
    previewRun: build.mutation<PreviewRunResult, PreviewRunBody>({
      query: (body) => ({
        url: '/admin/agentEvals/runs/preview',
        method: 'POST',
        body,
      }),
    }),
    createRun: build.mutation<AgentTestRun, CreateRunBody>({
      query: (body) => ({
        url: '/admin/agentEvals/runs',
        method: 'POST',
        body,
      }),
      invalidatesTags: [{ type: 'AgentTestRuns', id: 'LIST' }],
    }),
  }),
  overrideExisting: false,
});

export const { useGetRunsQuery, useGetRunQuery, usePreviewRunMutation, useCreateRunMutation } = runsApi;

export default runsApi;
